import React from 'react';
interface BrandMarkProps {
  size?: 'sm' | 'lg';
  className?: string;
}
export function BrandMark({
  size = 'sm',
  className = ''
}: BrandMarkProps) {
  const isLarge = size === 'lg';
  return <span className={`inline-flex flex-col items-start leading-none ${className}`} data-id="element-26" data-mp="tissc450axhx">
      <span className={`font-script text-noir -mb-1 ml-1 ${isLarge ? 'text-4xl' : 'text-xl'}`} data-id="element-27" data-mp="okhgxoz2cexl">
        Juste
      </span>
      <span className={`bg-jaune text-noir font-display uppercase tracking-tight border-[3px] border-noir ${isLarge ? 'text-4xl md:text-5xl px-3 py-1' : 'text-lg px-2 py-0.5'}`} data-id="element-28" data-mp="1m7ge00to3ow0">
        Au coin <span className="text-rouge" data-id="element-29" data-mp="1cftxboyk8xlv">d</span>’la rue
      </span>
      {isLarge && <span className="mt-2 font-display uppercase text-noir text-xs md:text-sm tracking-[0.18em]" data-id="element-30" data-mp="17h0v4soq4t10">
          Explorez les rues du monde avec vos papilles
        </span>}
    </span>;
}